<template>
<div>
  <div :style="chartStyle" class="mt-base">
    <div class="alarm-chart-title" v-text="$t('alarmTrend.alarmTrendChart')"></div>
    <el-popover
      placement="bottom-end"
      width="450"
      trigger="click"
      v-model="timePopperVis">
      <span 
        v-for="item in timeList" 
        class="choosen-btn mr-base" 
        :key="item"
        v-text="item" 
        @click="chooseTime(item)"></span>
      <div style="margin-top: 4px;">
        <el-date-picker 
          value-format="timestamp" 
          style="width: 180px;" 
          v-model="startTime" 
          type="date">
        </el-date-picker>
        <span v-text="$t('alarmTrend.to')"></span>
        <el-date-picker 
          value-format="timestamp" 
          style="width: 180px;" 
          v-model="endTime" 
          type="date">
        </el-date-picker>
        <el-button 
          type="primary" 
          v-text="$t('common.search')" 
          @click="searchChartTime"
          v-g-rac="gRac('timely@search')"></el-button>
      </div>
      <span slot="reference" v-text="choosenTime" class="choosen-btn  btn-position" @click="timePopperVis = true"></span>
    </el-popover>
    <chart-base
      v-if="showChart"
      ref="alarmTrend" 
      chart-id="alarmTrend" 
      :chart-data="chartData" 
      :chart-style="chartOpt"></chart-base>
  </div>
  <div class="alarmQuery__form">
    <el-form ref="form" :model="timelyForm" :inline="true" input-width="200px">
        <el-form-item :label="$t('alarmQuery.alarmType')">
          <g-select :list="alarmTypeList" :defaultAll="defaultAll" v-model="timelyForm.alarmType"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmQuery.alarmLevel')">
          <g-select :list="alarmLevelList" :defaultAll="defaultAll" v-model="timelyForm.alarmLevel"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmQuery.table.continueTime')">
          <g-select :list="alarmContinueList" :defaultAll="defaultAll" v-model="timelyForm.continueTime"></g-select>
        </el-form-item>
        <el-button type="primary" @click="timelySearch" v-g-rac="gRac('alarmQueryCurrent_search')">{{ $t('common.search') }}</el-button>
    </el-form>
    <el-table-extend
      :data="timelyTData" 
      :head="tableHead"
      :currentChange="timelyCurrentChange"
      :sizeChange="timelySizeChange"
      border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
              :control="timelyTableControl" 
              :data="data" 
              :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
    </el-table-extend>
  </div>
  <dialog-detail
    key="timelyDatail"
    :title="$t('alarmQuery.alarmDetail')" 
    :size="2" 
    :label-size="2" 
    :visible.sync="timelyDialogDetailShow" 
    :model="dialogModel"
    :detail-data="dialogData">
  </dialog-detail>
</div>
    
</template>
<script>
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import exportTips from '@/components/mixins/exportTips'
  import dialogForm from '@/components/dialogForm'
  import dialogDetail from '@/components/dialogDetail'
  import alarmQueryBiz from '@/logic/intelligentMonitor/alarmQueryBiz.js'
  import rac from '@/plugins/rac-mixin.js'
  import TimeFormat from '@/utils/timeFormat.js'
  import {extend} from '@/utils/tool.js'
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import chartBase from '@/components/chart/chart-base.vue'

  const DIC_MAP = {
    alarmType: 'ops_resource_type',
    alarmLevel: 'ops_alarm_level'
  }
  export default {
    mixins: [dic, table, rac, exportTips],
    data () {
      const that = this
      return {
        defaultAll: true,
        timelyForm: {
          siteCode: '',
          alarmType: '',
          alarmLevel: '',
          continueTime: ''
        },
        currentPage: 1,
        perPageCount: 10,
        timelyTableControl: [{
          label: that.$t('common.check'),
          callback: that.e_timelyCheck,
          rac: () => that.gRac('timely_check')
        }],
        infoList: [],
        infoTotalCount: '',
        infoCurrentCount: '',
        infoTableData: [],
        infoLastTime: '',
        alarmTypeList: {},
        alarmLevelList: {},
        alarmContinueList: {},
        dialogFormShow: false,
        dialogDetailShow: false,
        timelyDialogDetailShow: false,
        dialogData: [],
        dialogDataForDetail: [],
        dialogModel: {},
        dialogDetailModel: {},
        tableHead: [],
        timelyTData: {},
        doExport: null,
        chartStyle: {
          width: '100%',
          height: '300px',
          position: 'relative'
        },
        chartData: {},
        chartOpt: null,
        legendList: [],
        timeList: [this.$t('alarmTrend.lastWeek'), this.$t('releaseStatistics.lastMonth')],
        choosenTime: this.$t('alarmTrend.lastWeek'),
        startTime: '',
        endTime: '',
        timePopperVis: false,
        continueTimeList: [],
        domStyle: {}
      }
    },
    props: {
      showChart: Boolean
    },
    components: {
      dialogForm,
      dialogDetail,
      chartBase
    },
    methods: {
      setDialogData () {
        let setData = [
          {
            label: this.$t('alarmQuery.alarmName'),
            key: 'alarmName',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmType'),
            key: 'alarmType',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.trgType'),
            key: 'trgType',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmObject'),
            key: 'alarmObject',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmCode'),
            key: 'alarmCode',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmAddress'),
            key: 'alarmAddress',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmDesc'),
            key: 'alarmContent',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.alarmTime'),
            key: 'alarmTime',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.continueTime'),
            key: 'continueTime',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.table.alarmLevel'),
            key: 'alarmLevel',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.table.alarmElement'),
            key: 'alarmElement',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.table.operator'),
            key: 'operator',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.table.alarmSource'),
            key: 'alarmSource',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.recoverTime'),
            key: 'recoverTime',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.processPlan'),
            key: 'processPlan',
            type: 'textarea',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.locationInfo'),
            key: 'locationInfo',
            type: 'textarea',
            disabled: true
          },
          {
            label: this.$t('alarmQuery.advise'),
            key: 'advise',
            type: 'textarea',
            disabled: true
          }
        ];
        extend(true, this.dialogData, setData)
        this.dialogData.forEach((item) => {
          this.dialogModel[item.key] = ''
        })
      },
      init () {
        this.setDialogData()
        this.getDicList()
      },
      initTable () {
        this.tableHead = [
          { key: 'alarmCode', label: this.$t('alarmQuery.table.alarmCode') },
          { key: 'alarmName', label: this.$t('alarmQuery.table.alarmName'), showOverflowTooltip: true },
          { key: 'alarmLevel', label: this.$t('alarmQuery.table.alarmLevel'), formatter: 'Dictionary', formatterDic: this.alarmLevelList },
          { key: 'alarmType', label: this.$t('alarmQuery.table.alarmType'), formatter: 'Dictionary', formatterDic: this.alarmTypeList },
          { key: 'alarmElement', label: this.$t('alarmQuery.table.alarmElement') },
          { key: 'alarmAddress', label: this.$t('alarmQuery.table.alarmAddress') },
          { key: 'alarmContent', label: this.$t('alarmQuery.table.alarmContent'), showOverflowTooltip: true },
          { key: 'alarmSource', label: this.$t('alarmQuery.table.alarmSource')},
          { key: 'alarmTime', label: this.$t('alarmQuery.table.alarmTime') },
          { key: 'recoverTime', label: this.$t('alarmQuery.table.recoverTime') },
          { key: 'operator', label: this.$t('alarmQuery.table.operator') }
        ]
      },
      async getDicList () {
        await Promise.all([
          this.dGetDictionaryByCode('alarmType'),
          this.dGetDictionaryByCode('alarmLevel'),
          this.dGetDictionaryByCode('continue_time'),
          this.dGetDictionaryByCode('triggertype')
        ])
        this.alarmTypeList = { ...this.dDictionary.alarmType }
        this.alarmLevelList = { ...this.dDictionary.alarmLevel }
        this.alarmContinueList = { ...this.dDictionary.continue_time }
        this.triggertypeList = { ...this.dDictionary.triggertype }
        setTimeout(() => {
          this.initTable()
          this.timelySearch()
          this.startTime = Date.now() - (86400 * 1000 * 7)
          this.endTime = Date.now()
          this.getChartData(this.startTime, this.endTime)
        }, 200)
      },
      timelyCurrentChange (data) {
        this.currentPage = data
        this.e_search()
      },
      timelySizeChange (data) {
        this.currentPage = 1
        this.perPageCount = data
        this.e_search()
      },
      timelySearch () {
        this.currentPage = 1
        this.e_search()
      },
      e_search () {
        let d = {
          ...this.timelyForm,
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        d.continueTime = d.continueTime ? d.continueTime * 60 * 1000 : ''; //分钟转毫秒给后端计算
        Object.keys(this.timelyForm).forEach((item) => {
          if (this.timelyForm[item] === '') {
            delete d[item]
          }
        })
        alarmQueryBiz.queryHistory(d).then((data) => {
          data.dataList.forEach((item) => {
            Object.keys(item).map(function (keyItem, keyIndex, keyArray) {
              if (keyItem === 'continueTime') {
                item[keyItem] = TimeFormat.millisecondToDate(item[keyItem])
              }
              if (keyItem === 'recoverTime') {
                item[keyItem] = TimeFormat.getFormatTime(item[keyItem])
              }
              if (keyItem === 'alarmTime') {
                item[keyItem] = TimeFormat.getFormatTime(item[keyItem])
              }
            })
          })
          this.timelyTData = data
        })
      },
      e_timelyCheck (d) {
        this.timelyDialogDetailShow = true
        Object.keys(this.dialogModel).forEach((item) => {
          this.dialogModel[item] = item === 'trgType' ? this.triggertypeList[d[item]] : d[item]
        })
      },
      selectionChange (d) {
        this.selection = d
      },
      tabChange (e) {
        this.mode = e.index
      },
      setChartOpt () {
        this.chartOpt = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            type: 'scroll',
            width: '70%',
            top: '4%',
            data: this.legendList
          }
        }
      },
      setDefaultCount() { //依赖于this.alarmLevelList的结果
        const _keys = Object.values(this.alarmLevelList)
        const obj = {}
        _keys.forEach(item => {
          obj[item] = 0
        })
        return obj
      },
      translateData2Chart (data) {
        let arr = []
        this.legendList = [...Object.values(this.alarmLevelList)]
        for (let i in data) {
          let obj = {...this.setDefaultCount()}
          obj.time = i;
          if (data[i].length > 0) {
            data[i].map((item, index) => {
              const _level = this.alarmLevelList[item.alarmLevel]
              obj[_level] = item.count
            })
          }
          arr.push({ ...obj })
        }
        return arr
      },
      getChartData (startTime, endTime) {
        alarmQueryBiz.getAlarmLevelTrend({
          startTime: startTime,
          endTime: endTime
        }).then(data => {
          let arr = this.translateData2Chart(data)
          this.setChartOpt()
          this.$nextTick(() => {
            this.drawChart(arr)
          })
        })
      },
      drawChart (data) {
        let labelMap = {}
        this.legendList.map(item => { labelMap[item] = item })
        this.chartData = {
          rows: data,
          columns: ['time', ...this.legendList],
          // formatMap: {
          //   time: 'TIMELONG'
          // },
          labelMap: labelMap,
          seriesStyle: {
            lineStyle: {
              normal: {
                width: 1.6
              }
            },
            symbol: 'emptyCircle'
          }
        }
      },
      chooseTime (item) {
        if (item === this.$t('alarmTrend.lastWeek')) {
          this.startTime = new Date().getTime() - (86400 * 1000 * 7)
          this.endTime = new Date().getTime()
        } else if (item === this.$t('releaseStatistics.lastMonth')) {
          this.startTime = new Date().getTime() - (86400 * 1000 * 30)
          this.endTime = new Date().getTime()
        }
        this.getChartData(this.startTime, this.endTime)
        this.choosenTime = item
        this.timePopperVis = false
      },
      searchChartTime () {
        this.getChartData(this.startTime, this.endTime)
        this.choosenTime = `${TimeFormat.getFormatTime(this.startTime)} 
          ${this.$t('alarmTrend.to')} ${TimeFormat.getFormatTime(this.endTime)}`
        this.timePopperVis = false
      }
    },
    mounted () {
      this.init()
    }
  }
</script>
<style scoped>
  .mt-base{
    margin-bottom: 20px;;
  }
  .choosen-btn {
    font-size: 14px;
    color: #3385ff;
    cursor: pointer;
  }
  .btn-position {
    position: absolute;
    z-index: 99;
    right: 10px;
    top: 10px;
  }
  .alarm-chart-title {
    font-weight: bolder;
    font-size: 16px;
    position: absolute;
    z-index: 99;
    left: 10px;
    top: 10px;
  }
</style>
